import {
  findEdlinkIdentity,
  findGoogleIdentity,
  UserIdentityProviderKey,
  UserIdentityStatus,
  type FullStudent,
  type UserIdentityApi,
  type UserIdentityProviderView,
  type UpdateUserIdentitiesOptions,
} from '@airreading/common/data';

function findIdentityForProvider(
  provider: UserIdentityProviderKey,
  identities: UserIdentityApi[],
): UserIdentityApi | undefined {
  return provider === UserIdentityProviderKey.google ? findGoogleIdentity(identities) : findEdlinkIdentity(identities);
}

function getProviderIdentity(provider: UserIdentityProviderKey, student: FullStudent): UserIdentityProviderView {
  const identity = findIdentityForProvider(provider, student.userIdentities);

  if (identity) {
    return { status: identity.status, iss: identity.iss, sub: identity.sub ?? '' };
  }

  return { status: UserIdentityStatus.inactive, iss: '', sub: '' };
}

export function buildUserIdentitiesDefaultValues(student: FullStudent): UpdateUserIdentitiesOptions {
  return {
    google: getProviderIdentity(UserIdentityProviderKey.google, student),
    edlink: getProviderIdentity(UserIdentityProviderKey.edlink, student),
  };
}
